import { HTMLAttributes } from 'react';

import { AccountCardProps } from '@app/common/components/AccountCard';

interface OmitFields {
  readonly __typename: string
}

export type ExtendedAccount<T> = Omit<T, keyof OmitFields>;

export enum AccountsDropDownItemType {
  BusinessBanking = 'BusinessBanking',
  Cheking = 'Checking',
  CreditLine = 'CreditLine',
  CreditCard = 'CreditCard',
  External = 'External',
  Hidden = 'Hidden',
  Investment = 'Investment',
  Loan = 'Loan',
  M2M = 'M2M',
  NewM2MPayee = 'NewM2MPayee',
  PayPal = 'PayPal',
  Savings = 'Savings',
}

export type AccountsDropDownItemProps<T> = AccountCardProps & HTMLAttributes<HTMLButtonElement> & {
  readonly extended?: boolean
  readonly isHidden?: boolean
  readonly selected?: boolean
  readonly value: T
};

export interface AccountsDropDownOptionProps {
  action: string
  data?: any
}

export interface GroupOfDropDownAccounts<T> {
  readonly accounts: T[]
  readonly name: string
}
